import { CheckboxInput, CheckboxInputProps, CheckboxInputLayoutProps } from 'ui-builder';

export type {
  CheckboxInputProps as CheckboxProps,
  CheckboxInputLayoutProps as CheckboxLayoutProps,
};

export default CheckboxInput;
